import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { ArrowRight, Award, Flame, Trophy, Users } from "lucide-react";

function timeAgo(iso) {
  if (!iso) return "";
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  return `${Math.floor(h / 24)}d`;
}

function lineFor(e) {
  const p = e.payload || {};
  const h = e.author?.display_handle || "Someone";
  switch (e.kind) {
    case "badge_unlocked":
      return { icon: <Award className="w-3.5 h-3.5" />, text: <><strong>{h}</strong> earned <strong>{p.badge_name}</strong></> };
    case "streak_milestone":
      return { icon: <Flame className="w-3.5 h-3.5 text-orange-500" />, text: <><strong>{h}</strong> hit a <strong>{p.days}-day streak</strong></> };
    case "mock_exam_pass":
      return { icon: <Trophy className="w-3.5 h-3.5 text-amber-500" />, text: <><strong>{h}</strong> passed a mock exam <strong>{p.accuracy}%</strong></> };
    default:
      return { icon: null, text: <strong>{h}</strong> };
  }
}

export default function FriendUpdatesCard() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/feed/highlights")
      .then((r) => setEvents(r.data.events || []))
      .catch(() => setEvents([]));
  }, []);

  if (events === null) return null;          // still loading
  if (events.length === 0) return null;       // no friends or no activity → keep dashboard tidy

  return (
    <Card className="p-5 border-slate-200" data-testid="dashboard-friend-updates-card">
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 flex items-center gap-1.5">
          <Users className="w-3.5 h-3.5" /> Friend Updates
        </div>
        <Link to="/student/feed" className="text-xs text-slate-500 hover:text-indigo-600 inline-flex items-center gap-1" data-testid="dashboard-feed-view-all">
          View all <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
      <ul className="mt-3 space-y-2">
        {events.map((e) => {
          const l = lineFor(e);
          return (
            <li key={e.id} className="flex items-center gap-2 text-sm text-slate-700">
              <span className="grid place-items-center w-6 h-6 rounded-full bg-indigo-50 text-indigo-600 shrink-0">{l.icon}</span>
              <span className="flex-1 min-w-0 truncate">{l.text}</span>
              <span className="text-[11px] text-slate-400 tabular-nums shrink-0">{timeAgo(e.created_at)}</span>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
